import { render, staticRenderFns } from "./CommunityTile.vue?vue&type=template&id=350010e0&scoped=true&"
import script from "./CommunityTile.vue?vue&type=script&lang=js&"
export * from "./CommunityTile.vue?vue&type=script&lang=js&"
import style0 from "./CommunityTile.vue?vue&type=style&index=0&id=350010e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350010e0",
  null
  
)

export default component.exports